import ROUTES from '../routes';
import AutoSettings from '../hoc/auto-settings/auto-settings';
import AutoSettingsList from '../hoc/auto-settings/list';
import AutoSettingsAddPair from '../hoc/auto-settings/create';
import AutoSettingsGeneral from '../hoc/auto-settings/general';
import AutoSettingsItem from '../hoc/auto-settings/item';

const AutoSettingsRoutes = {
  path: ROUTES.AUTO_SETTINGS,
  element: <AutoSettings />,
  children: [
    {
      path: ROUTES.AUTO_SETTINGS_CURRENCY,
      element: <AutoSettingsList />,
      children: [
        {
          path: ROUTES.AUTO_SETTINGS_ADD,
          element: <AutoSettingsAddPair />,
        },
        {
          path: ROUTES.AUTO_SETTINGS_GENERAL,
          element: <AutoSettingsGeneral />,
        },
        {
          path: ROUTES.AUTO_SETTINGS_EDIT,
          element: <AutoSettingsItem />,
        },
      ],
    },
  ],
};

export default AutoSettingsRoutes;
